import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { GlobalConstants } from 'src/app/base/global.constants';
import {
  deleteUserStories,
  getUserStories,
  getUserStoriesWithSorting,
  saveUserStories,
  saveUserStoriesOrder,
  setUserStories,
  setUserStoriesOrder,
  deleteFileAttachments,
  selectFileAttachments
} from '../actions/userstories.actions';
import { setRoles } from '../actions/roles.actions';

@Injectable()
export class UserStoriesEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getUserStories$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getUserStories),
        map((action) => {
          return combineLatest([
            this.baseService[action.apiConstants?.roles.method](
              action.apiConstants.roles,
              GlobalConstants.dataTableHeaders
            ),
            this.baseService[action.apiConstants?.userStoryData.method](
              action.apiConstants.userStoryData,
              GlobalConstants.dataTableHeaders
            ),
            this.baseService[action.apiConstants?.order.method](action.apiConstants.order)
          ]).subscribe((results: any) => {
            this.store.dispatch(
              setRoles({
                rolesTable: results[0]
              })
            );
            this.store.dispatch(
              setUserStories({
                userStoriesTable: results[1]
              })
            );
            if (results[2]) {
              this.store.dispatch(
                setUserStoriesOrder({
                  userStoriesOrder: results[2]
                })
              );
            } else {
              this.store.dispatch(
                setUserStoriesOrder({
                  userStoriesOrder: { orders: null }
                })
              );
            }
          });
        })
      ),
    { dispatch: false }
  );
  getUserStoriesWithSorting$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getUserStoriesWithSorting),
        map((action) =>
          this.baseService.get(action.apiConstants, action.params).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(
                setUserStoriesOrder({
                  userStoriesOrder: result
                })
              );
            } else {
              this.store.dispatch(
                setUserStoriesOrder({
                  userStoriesOrder: { orders: null }
                })
              );
            }
          })
        )
      ),
    { dispatch: false }
  );
  saveUserStoriesorder$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveUserStoriesOrder),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](
            action.saveAPiConstants,
            action.userstoriesOrderData
          ).subscribe((result: any) => {
            // this.store.dispatch(setUserStoriesOrder({
            //     userStoriesOrder: result
            // }))
          })
        )
      ),
    { dispatch: false }
  );
  saveUserStories$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveUserStories),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](action.saveAPiConstants, action.userstoriesData).subscribe(
            (result: any) => {
              this.store.dispatch(
                setUserStories({
                  userStoriesTable: result
                })
              );
            }
          )
        )
      ),
    { dispatch: false }
  );

  deleteUserStories$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteUserStories),
        map((action) =>
          this.baseService[action.deleteStoryApiConstants?.method](
            action.deleteStoryApiConstants,
            action.ids
          ).subscribe()
        )
      ),
    { dispatch: false }
  );

  deleteFileAttachmentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteFileAttachments),
        map((action: any) => {
          const apiConstants = { ...action.deleteFileAttachmentApiConstants };
          apiConstants.url = action.deleteFileAttachmentApiConstants.url + action.fileAttachmentsId;

          return this.baseService[action.deleteFileAttachmentApiConstants?.method](apiConstants).subscribe(
            (response: any) => {
              this.store.dispatch(
                selectFileAttachments({
                  response: response
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
}
